import React, {useRef, useEffect, useCallback} from "react"
import {useSelector, useDispatch} from "react-redux"
import useWindowSize from "../../hooks/useWindowSize"

import Viewer2d from "../../lib/viewer2d"

import {
  createCanvasApi,
  clearCanvasApi,
} from "../../redux/actions/canvasApiActions"

import {
  setProduct2dActivePart,
  clearProduct2dActivePart,
  clearActiveObject,
  setProduct2dCanvasState,
  clearProduct2dCanvasState,
  setActiveObject,
  setActiveObjects,
  clearProduct2d,
  setLoader,
} from "../../redux/actions/product2dActions"

import "./workzone.scss"

/**
 * Component container for canvas
 * @component
 * @example
 * return (
 *  <WorkZone />
 * )
 */

const WorkZone = () => {
  const fabricZone = useRef(null)
  const windowSize = useWindowSize()

  const dispatch = useDispatch()

  const product2d = useSelector(state => state.product2d)
  const makFabric = useSelector(state => state.makFabric)
  const product2dActivePart = useSelector(state => state.product2dActivePart)
  const product2dCanvasState = useSelector(state => state.product2dCanvasState)
  const apiKey = useSelector(state => state.apiKey)

  /**
   *  CREATE FABRIC INSTANCE & ADDED TO REDUX
   */
  useEffect(() => {
    if (fabricZone.current && !makFabric && apiKey) {
      dispatch(
        createCanvasApi(
          new Viewer2d({
            node: fabricZone.current,
            setSpinner: e => dispatch(setLoader(e)),
            key: apiKey,
            options: {},
          }),
        ),
      )
    }
  }, [makFabric, dispatch, apiKey])

  useEffect(() => {
    product2d.parts.length &&
      !product2dCanvasState.length &&
      dispatch(
        setProduct2dCanvasState(
          product2d.parts.map(item => ({name: item.name, state: ""})),
        ),
      )
  }, [dispatch, product2d.parts, product2dCanvasState.length])

  /**
   *  INIT CANVAS STATE
   */
  useEffect(() => {
    if (makFabric) {
      makFabric.help.activeObj = e => dispatch(setActiveObject(e.target))
      makFabric.help.activeObjs = e => dispatch(setActiveObjects(e))
    }
  }, [dispatch, makFabric])

  /**
   *  DEFAULT ACTIVE PART
   */
  useEffect(() => {
    if (product2d.parts.length && !product2dActivePart) {
      dispatch(setProduct2dActivePart(product2d.parts[0]))
    }
  }, [dispatch, product2d.parts, product2dActivePart])

  useEffect(() => {
    if (makFabric && product2dActivePart) {
      let a = product2dCanvasState.find(
        item => item.state === "" && item.name === product2dActivePart.name,
      )
      if (a) {
        // console.log("ADDED PRODUCT")
        dispatch(setLoader(true))
        makFabric.addProduct(
          product2dActivePart.image,
          product2dActivePart.name,
          product2dActivePart.config || {},
          product2d.color
        )
      }
    }
  }, [makFabric, dispatch, product2dActivePart, product2dCanvasState])

  /**
   *  RESIZE CANVAS
   */
  const resize = useCallback(() => {
    if (makFabric) {
      makFabric.canvasResize(
        windowSize.width,
        windowSize.height,
      )
    }
  }, [makFabric, windowSize])

  useEffect(() => {
    resize()
    window.addEventListener("resize", resize)
    
    return () => window.removeEventListener("resize", resize)
  }, [makFabric, resize, windowSize])

  /**
   * CLEAR STATE
   */
  useEffect(() => {
    return () => {
      dispatch(clearCanvasApi())
      dispatch(clearProduct2dCanvasState())
      dispatch(clearActiveObject())
      dispatch(clearProduct2d())
      dispatch(clearProduct2dActivePart())
    }
  }, [dispatch])

  return (
    <div className="workZoneContainer">
      <div className="workZoneWrapper">
        <canvas ref={fabricZone}></canvas>
      </div>
    </div>
  )
}

export default WorkZone
